module.exports = __webpack_public_path__ + "static/media/0300005.54a1be94.jpg";